/** biome-ignore-all lint/complexity/useSimpleNumberKeys: this rule would messup our color codes like 500_8 => 5008 */
import { alpha, type ThemeOptions } from '@mui/material';
import type { DeepPartial } from 'types/utils';

// Base color: #48A8A0, step up 8%, step down 11%
// https://www.tailwindshades.com/#color=175%2C40%2C47.05882352941176&step-up=8&step-down=11&hue-shift=0&name=keppel&base-stop=5&v=1&overrides=e30%3D
const primary = {
  lighter: '#B4DFDB',
  light: '#7BC6C0',
  main: '#48A8A0',
  dark: '#265955',
  darker: '#163230',
};

// https://www.tailwindshades.com/#color=144%2C40%2C47.05882352941176&step-up=8&step-down=11&hue-shift=0&name=ocean-green&base-stop=5&v=1&overrides=e30%3D
const success = {
  lighter: '#B4DFC5',
  light: '#7BC699',
  main: '#48A86E',
  dark: '#26593B',
  darker: '#163221',
};

// https://www.tailwindshades.com/#color=29.04255319148936%2C88.67924528301886%2C58.4313725490196&step-up=8&step-down=11&hue-shift=0&name=jaffa&base-stop=5&v=1&overrides=e30%3D
const warning = {
  lighter: '#FCE6D1',
  light: '#F8BC84',
  main: '#F39237',
  dark: '#E4760E',
  darker: '#7A3F07',
};

// Base color: #9AA7AC, step up 8%, step down 14%
// https://www.tailwindshades.com/#color=197.3684210526316%2C10%2C64&step-up=8&step-down=11&hue-shift=0&name=hit-gray&base-stop=5&v=1&overrides=e30%3D
const grey = {
  100: '#F4F5F6',
  200: '#DDE2E3',
  300: '#C7CED1',
  400: '#B0BBBF',
  500: '#9AA7AC',
  600: '#73858C',
  700: '#536065',
  800: '#323A3E',
  900: '#121516',
  500_8: alpha('#9AA7AC', 0.08),
  500_12: alpha('#9AA7AC', 0.12),
  500_16: alpha('#9AA7AC', 0.16),
  500_24: alpha('#9AA7AC', 0.24),
  500_32: alpha('#9AA7AC', 0.32),
  500_48: alpha('#9AA7AC', 0.48),
  500_56: alpha('#9AA7AC', 0.56),
  500_80: alpha('#9AA7AC', 0.8),
};

export const themeOptions: DeepPartial<ThemeOptions> = {
  palette: {
    primary,
    success,
    warning,
    grey,
    background: {
      default: '#213C47',
    },
    text: {
      primary: grey[800],
      secondary: grey[600],
      disabled: grey[500],
    },
    action: {
      hover: alpha(primary.main, 0.32), // Dropdown menu hover background color
    },
    navBar: {
      menuActiveBg: primary.main,
      menuActiveText: '#fff',
      menuDefaultText: grey[200],
      menuHoverBg: alpha(primary.main, 0.32),
      menuHoverText: '#fff',
      menuSecondaryText: grey[300],
      searchHoverBorder: primary.light,
    },
  },
};
